import { createContext } from "react";

const FooterVisibilityContext = createContext(true);
export default FooterVisibilityContext;
